import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mpf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    try {
      const m = (r.config?.method || "").toLowerCase();
      const u = r.config?.url || "";
      if (["post", "put", "delete"].includes(m) && /(animal-batches|products)/.test(u)) {
        window.dispatchEvent(new Event("mpf:usage-changed"));
      }
    } catch (e) { /* noop */ }
    return r;
  },
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("mpf_token")) {
      localStorage.removeItem("mpf_token");
      if (!window.location.pathname.startsWith("/boutique") && window.location.pathname.startsWith("/app")) {
        window.location.href = "/login";
      }
    }
    if (err.response?.status === 403 && typeof err.response?.data?.detail === "string" && err.response.data.detail.includes("FARM_SUSPENDED")) {
      localStorage.removeItem("mpf_token");
      toast.error("Votre abonnement est suspendu suite à un échec de paiement. Consultez l'e-mail de régularisation qui vous a été envoyé.");
      if (window.location.pathname.startsWith("/app")) {
        setTimeout(() => { window.location.href = "/login"; }, 1500);
      }
    }
    if (err.response?.status === 402) {
      toast.error(apiError(err), {
        action: {
          label: "Passer à un plan supérieur",
          onClick: () => { window.location.href = "/app/abonnement"; },
        },
      });
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
